export enum ELocationDeterminant {
    gps = 'gps',
    cellId = 'cell_id',
}

export function getLocationDeterminantFromString(value: string): ELocationDeterminant {
    switch (`${value}`.toLowerCase().trim()) {
        case 'cell_id':
            return ELocationDeterminant.cellId;

        case 'gps':
        default:
            return ELocationDeterminant.gps;
    }
}
